import axios from "axiosConfig";

const getData = async () => {
  const { data } = await axios.get("api/dcaorders/");
  console.log('totalData', data)
  return data;
};

const ChartService = {
  getData,
};

export default ChartService;
